import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ErrorBoundaryApp } from '@sharedUi/ErrorBoundary';
import 'assets/sass/actions.sass';
// import 'assets/scss/home-page/map-block/_map-block.scss';
import 'assets/scss/index.scss';
import 'assets/scss/_jivosite.scss';
import { wrapper } from '@app/redux/store';
import RouterSpinner from '@sharedComponents/RouterSpinner';
import ExternalLibs from '@sharedComponents/ExternalLibs';
import numeral from 'numeral';
import config from '@app/config';
import ModalProvider from '@app/components/shared/Modal';
import { FeedBackGlobal } from '@features/feedBack';
import { useInitJivoSite } from '@features/jivoSite';
import ExternalLibsHead from '@app/components/shared/ExternalLibsHead';
import { OpenReplayComponent } from '@features/openReplay';

if (numeral.locales.rul === undefined) {
  numeral.register('locale', 'rul', {
    delimiters: {
      thousands: ' ',
      decimal: '.',
    },
    abbreviations: {
      thousand: 'тыс.',
      million: 'млн.',
      billion: 'млрд.',
      trillion: 'трлн.',
    },
  });
}

numeral.locale('rul');

const MyApp = ({ Component, pageProps }) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
  }
  useInitJivoSite();
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_KEY}>
      {config.openReplayOn && <OpenReplayComponent />}
      <FeedBackGlobal />
      <ErrorBoundaryApp>
        <ModalProvider>
          <Component {...pageProps} />
        </ModalProvider>
        <RouterSpinner />
        {config.environment !== 'LOCAL' && <ExternalLibs />}
        <ExternalLibsHead />
      </ErrorBoundaryApp>
    </GoogleReCaptchaProvider>
  );
};

export default wrapper.withRedux(MyApp);
